import SocialPostContainer from './SocialPostContainer';

export default SocialPostContainer;
